<div
   class="expandable-panel"
   [class.expanded]="expanded">
   <div
      *ngFor="let kpi of kpis"
      class="left-bar"
      [style.background-color]="colorMap[kpi]"></div>
   <div class="panel-content">
      <div
         class="panel-header"
         (click)="toggleExpand()">
         <div class="header-top">
            <div class="title-block">
               <div class="title">{{ title }}</div>
               <!--<div
                  class="tags"
                  *ngIf="kpis?.length && kpiMap">
                  <span
                     class="tag"
                     *ngFor="let kpi of kpis"
                     [ngStyle]="{
                        'background-color': colorMap[kpi] || '#999',
                        color: 'white'
                     }">
                     {{ kpiMap[kpi].kpiName }}
                  </span>
               </div>-->

               <div class="metrics-block">
                  <div
                     class="metric"
                     *ngIf="vetcorAvg">
                     <span class="label">Vetcor Avg</span>
                     <span class="value">{{ vetcorAvg }} {{ units }}</span>
                  </div>
                  <div
                     class="metric"
                     *ngIf="current != null">
                     <span class="label">Current</span>
                     <span class="value">{{ current }} {{ units }}</span>
                  </div>
                  <div
                     class="metric"
                     *ngIf="!editable">
                     <span class="label">Target</span>
                     <span class="value">{{ target }}</span>
                  </div>
                  <div
                     class="metric"
                     (click)="$event.stopPropagation()"
                     *ngIf="toggleEnabled">
                     <span class="label">Target</span>
                     <input
                        class="value-input"
                        type="text"
                        [(ngModel)]="target" />
                  </div>
               </div>
            </div>

            <div class="colorfulKpis-block">
               <img
                  *ngIf="kpis.toString().includes('1') && kpis.toString().includes('2') && kpis.toString().includes('3')"
                  src="assets/gtk/allKpis.jpg" />
               <img
                  *ngIf="kpis.toString().includes('4')"
                  src="assets/gtk/yellowKpis.jpg" />
               <img
                  *ngIf="kpis.toString().includes('5')"
                  src="assets/gtk/blueKpis.jpg" />
            </div>

            <div
               class="enableSwitch metrics-block"
               style="padding-top: 0px">
               <div
                  (click)="$event.stopPropagation()"
                  *ngIf="editable"
                  class="metric-toggle">
                  <p-inputSwitch [(ngModel)]="toggleEnabled"></p-inputSwitch>
               </div>
               <div class="chevron">
                  <i
                     [class.fa]="true"
                     [class.fa-chevron-down]="expanded"
                     [class.fa-chevron-right]="!expanded"></i>
               </div>
            </div>
         </div>
      </div>

      <div
         class="panel-body"
         *ngIf="expanded">
         <ng-content></ng-content>
      </div>
   </div>
</div>
